import { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import {
  add,
  error,
  errorinvoice,
  externalName,
  failedMsg,
  LabOrder,
  lmsIntent,
  LmstableHeading,
  LoadPrice,
  NewOrder,
  opd,
  optionValue,
  OrderEvent,
  orderMsg,
  orderSubmit,
  orderSucess,
  orderValidationmsg,
  priceFailedMsg,
  PriceList,
  priceListNotFound,
  Row,
  success,
} from './models'
import { startSxpProxy } from '../../utils/api'
import { LABS_PROJECT_ID, OPD_PROJECT_ID } from '../../utils/constants'
import { toast } from 'react-toastify'
import ToastMessage from '../lms/components/ToastMessage'
import { toastOptions } from '../lms/models'
import { getDoctorForVisit, saveOrder } from './utils'
import KeycloakService from '../../utils/keycloakService'
import { LAB_ORDERS_WRITE } from '../../utils/roles'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import {
  selectLocationById,
  selectSelectedLocationId,
} from '../location/locationSlice'
import { prepareOrderEventTests } from '../lms/utils'
import { readableDateTimeFormat } from '../../utils/dateUtils'
import Select from 'react-select'
import { Doctor } from '../scheduler/schedulerSlice'
import { useOrganizations } from '../lms/components/useOrganizations'
import { fetchSlotsDoctorsAsync, selectSlotsDoctors } from '../slots/slotsSlice'
import { setQueryParam } from '../membership/membershipSlice'
import { Button, IconButton } from '@mui/material'
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'
import { setLmsActiveTab, setLmsDateFilter } from '../lms/lmsSlice'
import {
  labDashboard,
  labordercreate,
  orderinvoice,
  visits,
} from '../bedManagement/endpoints/EndPoints'
import {
  CreateLabInvoice,
  getOdooProductPrice,
  UpdateLabInvoice,
} from '../../services/LmsService'

const OpdOrder = () => {
  const { id }: any = useParams()
  const [newrowadded, setNewRowAdded] = useState(false)
  const [patientId, setPatientId] = useState('')
  const [order, setOrder] = useState<LabOrder>({})
  const [orders, setOrders] = useState<LabOrder[]>([])
  const [activeIndex, setActiveIndex] = useState(0)
  const [origin, setOrigin] = useState('OPD')
  const locationId = useAppSelector(selectSelectedLocationId)
  const location = useAppSelector((state) =>
    selectLocationById(locationId, state)
  )
  const [selectedTests, setSelectedTests] = useState<any[]>([])
  const [rows, setRows] = useState<Row[]>([])
  const [ordersEvent, setOrdersEvent] = useState<OrderEvent[]>([])
  const [isRowAdded] = useState(false)
  const [testAdded, setTestAdded] = useState(false)
  const navigate = useNavigate()
  const [testNameOptions, setTestNameOptions] = useState<
    { label: string; value: string; panels: any; odoo_testId: any }[]
  >([])
  const [visitStatus, SetVisitStatus] = useState('')
  const [newRow, setNewRow] = useState<Row>({
    mode: null,
    requestedBy: null,
    sampleName: null,
    testName: null,
    panel: null,
    origin: null,
    price: 0,
  })
  const [isSaving, setIsSaving] = useState(false)
  const [priceLoading, setPriceLoading] = useState(false)
  const [externalText, setExternalText] = useState('')
  const reqPatnerId = newRow?.requestedBy?.odooId
  const dispatch = useAppDispatch()
  const handleModeChange = (selectedOption: any) => {
    setNewRow((prev) => ({ ...prev, mode: selectedOption }))
  }

  const executeFunction = () => {
    const state = {}
    startSxpProxy(LABS_PROJECT_ID, 'getAllPanelsApi', state)
      .then((data) => {
        const panelData: any = data?.data?.panel ?? []
        const tests = panelData?.map((test: any) => ({
          label: test?.name,
          value: String(test?.id),
          odoo_test_id: test?.odoo_test_id,
          sampleName: test?.sample?.name,
          sampleId: test?.sample?.id,
          panel: {
            name: test?.name,
            description: test?.description,
            id: test?.id,
            odoo_test_id: test?.odoo_test_id,
            lab_tests: test?.lab_tests,
            sampleId: parseInt(test?.sample?.value),
            sampleName: test?.sample?.name,
            processing_unit: '',
            price: test?.price ?? 0,
          },
        }))
        const selectedTestLabels = rows.map((row) => row.testName?.label)
        const filteredTests = tests.filter(
          (test: any) => !selectedTestLabels.includes(test.label)
        )
        setTestNameOptions(filteredTests)
      })
      .catch((error) => {
        console.error('Error fetching test names:', error)
        setTestNameOptions([])
      })
  }
  const handleTestNameChange = async (selectedOption: any) => {
    if (!selectedOption) return
    const updatedRow: any = {
      testName: {
        label: selectedOption?.label,
        value: selectedOption?.value,
        odoo_test_id: selectedOption?.odoo_test_id,
      },
      sampleName: {
        label: selectedOption?.panel?.sampleName,
        value: selectedOption?.panel?.sampleId,
      },
      panel: selectedOption?.panel,
    }

    const priceList = location?.resource?.type?.[0]?.coding?.find(
      (item: any) => item.code === PriceList
    )?.display
    setPriceLoading(true)
    const b2bOrigin = origin === 'B2B'
    try {
      const response = await getOdooProductPrice({
        selectedLocationId: location?.resource?.id,
        patient_identifier: id,
        partner_id: newRow?.requestedBy?.odooId || '',
        odootestid: selectedOption?.panel?.odoo_test_id,
        pricelist_id: priceList,
        b2b: b2bOrigin,
        reqOdooId: reqPatnerId || '',
      })

      const price =
        response?.data?.best_price || response?.data?.data?.best_price
      if (!price || price <= 0) {
        throw new Error(priceListNotFound)
      }
      updatedRow.price = price
      updatedRow.panel.price = price
      setNewRow((prev) => ({
        ...prev,
        ...updatedRow,
      }))
    } catch (e) {
      console.error(e)
      toast(<ToastMessage message={priceFailedMsg} />, {
        ...toastOptions,
        type: error,
      })
    } finally {
      setPriceLoading(false)
    }
  }
  const handleSave = async () => {
    if (!KeycloakService.hasRole([LAB_ORDERS_WRITE])) return
    if (!rows?.[0]?.testName) {
      toast(<ToastMessage message={orderValidationmsg} />, {
        ...toastOptions,
        type: error,
      })
      return
    }
    setIsSaving(true)
    const filteredPanels: any = rows?.map((row: Row) => row?.panel)
    const filteredLabTests: any = []
    const mode: 'visit' | 'patient' = locations.pathname.startsWith(visits)
      ? 'visit'
      : 'patient'
    const doctorName = await getDoctorForVisit(id ?? '')
    const locationName = location?.resource?.name ?? ''
    const locationId = location?.resource?.id
    const requestedBy = locations?.pathname?.startsWith(visits)
      ? doctorName
      : rows?.[rows?.length - 1]?.requestedBy?.value ===
        optionValue?.external?.value
      ? externalText
      : rows?.[rows?.length - 1]?.requestedBy?.value
    const reqOdooId = rows?.[rows?.length - 1]?.requestedBy?.odooId
    const reqDoctorRef = rows?.[rows?.length - 1]?.requestedBy?.doctorRef
    const odooTestIds = rows
      ?.map((row: any) => row?.panel?.odoo_test_id)
      ?.filter((id: any) => id !== null && id !== undefined)
    const updatedTestIds = odooTestIds?.reduce((acc: any[], id: number) => {
      const existing = acc?.find((item) => item?.product_id === id)
      if (existing) {
        existing.quantity += 1
      } else {
        acc?.push(
          order?.origin === optionValue?.b2b?.value
            ? {
                product_id: id,
                product_uom_qty: 1,
                order_ref: order?.ref_id,
                patient_id: id,
              }
            : { product_id: id, quantity: 1 }
        )
      }
      return acc
    }, [])
    try {
      let invoiceResponse = null
      if (origin == optionValue?.b2b?.value || origin?.toLowerCase() == opd) {
        if (order?.id) {
          invoiceResponse = await UpdateLabInvoice(
            order?.origin,
            updatedTestIds,
            order?.odoo_invoice_id,
            order?.ref_id
          )
          const result =
            invoiceResponse?.data?.data?.result || invoiceResponse?.data?.result
          if (result?.status !== success) {
            throw new Error(result?.message || failedMsg)
          }
        } else {
          invoiceResponse = await CreateLabInvoice(
            locationId,
            origin,
            odooTestIds,
            patientId || id,
            reqOdooId || null,
            reqDoctorRef
          )
        }
        const response = invoiceResponse?.data
        if (response?.odooApistatus === 'error') {
          toast(
            <ToastMessage message={response?.message || orderMsg?.failedmsg} />,
            {
              ...toastOptions,
              type: 'error',
            }
          )
          setIsSaving(false)
          return
        }
      }
      const odooInvoiceID = invoiceResponse?.data?.odoo_invoice_id || ''
      const RefID = invoiceResponse?.data?.ref_id || ''
      const saveOrderResponse = await saveOrder(
        mode,
        order,
        id,
        patientId || id,
        filteredPanels,
        filteredLabTests,
        locationName,
        0,
        0,
        requestedBy,
        origin,
        odooInvoiceID,
        RefID,
        locationId
      )
      setOrder(
        order?.id ? order : saveOrderResponse?.data?.insert_lab_orders_one
      )
      toast(<ToastMessage message={order?.id ? orderSucess : orderSubmit} />, {
        ...toastOptions,
        type: success,
      })
      setTimeout(() => {
        dispatch(setLmsDateFilter(new Date().toISOString().slice(0, 10)))
        dispatch(setLmsActiveTab('collection'))
        if (
          order?.origin?.toLowerCase() === opd ||
          origin?.toLowerCase() === opd
        ) {
          navigate(orderinvoice)
        } else {
          navigate(labDashboard)
        }
      }, 1500)
      getAllLabOrders()
      setNewRowAdded(false)
      const orderLab: LabOrder = order?.id
        ? saveOrderResponse.data?.update_lab_orders?.returning?.[0]
        : saveOrderResponse.data?.insert_lab_orders_one
      const stateObj: Partial<OrderEvent> = {
        updated_by: KeycloakService.getUsername(),
        order_id: orderLab?.id,
        type: order?.id ? 'ORDER_MODIFIED' : 'ORDERED',
        tests: prepareOrderEventTests(
          filteredPanels,
          filteredLabTests,
          order?.id ? 'ORDER_MODIFIED' : 'ORDERED'
        ),
      }
      await startSxpProxy(LABS_PROJECT_ID, lmsIntent?.createOrderEvent, {
        event: stateObj,
      })

      setOrder(order ?? {})
    } catch (err: any) {
      toast(<ToastMessage message={err.message || errorinvoice} />, {
        ...toastOptions,
        type: error,
      })
    } finally {
      setIsSaving(false)
    }
  }

  const handleSaveRow = () => {
    if (!newRow.sampleName) {
      alert(orderMsg?.sampleName)
      return
    }
    if (!newRow.testName) {
      alert(orderMsg?.TestName)
      return
    }
    const reqBy =
      rows?.length > 0 ? rows?.[0]?.requestedBy : newRow?.requestedBy
    const org = rows?.length > 0 ? rows?.[0]?.origin : newRow?.origin
    const updatedRows = [
      ...rows,
      {
        ...newRow,
        requestedBy: reqBy,
        origin: org,
      },
    ]
    setRows(updatedRows)
    const nextRow = {
      mode: newRow.mode,
      requestedBy: reqBy,
      origin: org,
      sampleName: null,
      testName: null,
      panel: null,
      price: 0,
    }
    setNewRow(nextRow)
    setNewRowAdded(true)
    if (newRow.testName) {
      setSelectedTests([...selectedTests, newRow.testName])
    }
    setTestAdded((prev) => !prev)
  }

  const handleRequestedByChange = (selectedOption: any) => {
    setNewRow((prev) => ({ ...prev, requestedBy: selectedOption }))
  }

  const handleOriginChange = (selectedOption: any) => {
    const selectedValue = selectedOption?.value || ''
    setOrigin(selectedValue)
    setNewRow((prev) => ({ ...prev, origin: selectedOption }))
  }
  const organizations = useOrganizations()
  const doctors = useAppSelector(selectSlotsDoctors)
  const handleDeleteRow = (index: number) => {
    setRows((prevRows: Row[]) => {
      const updatedRows = [...prevRows]
      updatedRows.splice(index, 1)
      return updatedRows
    })
    setNewRowAdded(true)
  }

  useEffect(() => {
    dispatch(fetchSlotsDoctorsAsync())
  }, [dispatch])

  const VisitTableRef = useRef<HTMLDivElement | null>(null)
  const fetchData = async () => {
    try {
      const labOrderData = await startSxpProxy(
        LABS_PROJECT_ID,
        lmsIntent?.getLabOrdersByPatientIdForOpd,
        { patientId: id, source: location?.resource?.name }
      )
      const orders: LabOrder[] = labOrderData?.data?.lab_orders ?? []
      setOrders(orders)
      handleActiveOrderChage(orders)
    } catch (err) {
      console.error(err)
    }
  }

  const getAllLabOrders = () => {
    const intent = lmsIntent?.getLabOrdersApi
    startSxpProxy(LABS_PROJECT_ID, intent, { visitId: id })
      ?.then((data: any) => {
        const orders: LabOrder[] = data?.data?.lab_orders ?? []
        setOrders(orders)
        handleActiveOrderChage(orders)
        const state = { encounterId: id }
        startSxpProxy(OPD_PROJECT_ID, lmsIntent?.getVisitApi, state)
          ?.then((data) => {
            setPatientId(data?.data?.subject?.reference?.split('/')?.[1])
            SetVisitStatus(data?.data?.statusHistory?.[0]?.status)
          })
          .catch((err) => {
            console.log(err)
          })
      })
      .catch((err) => {
        console.log(err)
      })
  }

  useEffect(() => {
    if (window.location.pathname === `${labordercreate}/${id}`) {
      fetchData()
    } else {
      getAllLabOrders()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])
  const handleActiveOrderChage = (orders: LabOrder[]) => {
    let activeOrder: any = {}
    // needed
    // if (window.location.pathname?.startsWith(labordercreate)) {
    //   const latestOrder = orders?.[orders?.length - 1]

    //   activeOrder =
    //     latestOrder?.order_events?.every((event) =>
    //       event?.tests?.every(
    //         (test) =>
    //           test.status === `${orderStatus?.orderedModified}` ||
    //           test.status === `${orderStatus?.ordered}`
    //       )
    //     ) && latestOrder.origin !== AB
    //       ? latestOrder
    //       : orders?.[-1] ?? {}
    // } else
    {
      activeOrder = orders[activeIndex] ?? {}
    }
    setOrder(activeOrder)
    const formattedRows: any = activeOrder?.panels?.map((panel: any) => {
      return {
        mode: {
          label: activeOrder?.package_id ? 'Package' : 'Test',
          value: activeOrder?.package_id ? 'package' : 'test',
        },
        requestedBy: {
          label: activeOrder?.requested_by,
          value: activeOrder?.requested_by,
        },
        origin: {
          label: activeOrder?.origin,
          value: activeOrder?.origin,
        },
        sampleName:
          panel?.sampleName && panel?.sampleId
            ? { label: panel?.sampleName, value: panel?.sampleId }
            : null,

        testName:
          panel?.name && panel?.id
            ? { label: panel?.name, value: panel?.id }
            : null,
        panel: panel || null,
      }
    })
    setRows(formattedRows || [])
    setOrdersEvent(activeOrder?.order_events ?? [])
    setOrder(activeOrder)
    if (
      activeOrder?.id &&
      activeOrder?.panels &&
      activeOrder?.panels?.length >= 1
    ) {
      setNewRow({
        mode: {
          label: activeOrder?.package_id ? 'Package' : 'Test',
          value: activeOrder?.package_id ? 'package' : 'test',
        },
        requestedBy: null,
        sampleName: null,
        testName: null,
        panel: null,
        origin: null,
      })
    } else {
      setNewRow({
        mode: null,
        requestedBy: null,
        sampleName: null,
        testName: null,
        panel: null,
        origin: null,
      })
    }
  }

  useEffect(() => {
    const resizeHandler = () => {
      const container = VisitTableRef.current
      if (container) {
        const availableHeight =
          window.innerHeight - container.getBoundingClientRect().top
        container.style.maxHeight = `${availableHeight - 90}px`
      }
    }
    window.addEventListener('resize', resizeHandler)
    resizeHandler()
    return () => {
      window.removeEventListener('resize', resizeHandler)
      dispatch(setQueryParam({ q: '', param: '' }))
    }
  }, [dispatch])

  useEffect(() => {
    executeFunction()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testAdded, rows])

  useEffect(() => {
    handleActiveOrderChage(orders)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeIndex])

  const locations = useLocation()

  useEffect(() => {
    if (locations.pathname.startsWith(labordercreate)) {
      setNewRow((prevState) => ({
        ...prevState,
        origin: optionValue?.origin,
      }))
    }
  }, [locations.pathname, setNewRow])
  const handleIndexChange = (index: any) => {
    setActiveIndex(index)
    setNewRowAdded(false)
  }
  const isPointerEventsDisabled = ordersEvent?.some((event) =>
    event.tests?.some(
      (test) => test.status !== 'ORDER_MODIFIED' && test.status !== 'ORDERED'
    )
  )
  const getRequestedByOptions = () => {
    const selfOption = optionValue?.self
    const externalOption = optionValue?.external

    const dynamicOptions =
      newRow?.origin?.value === optionValue?.b2b?.value
        ? organizations?.map((org: any) => ({
            value: org?.name,
            label: org?.name,
            odooId: org?.odoo_partner_id,
          }))
        : doctors?.map((d: Doctor) => {
            const qualificationPart = d?.qualification
              ? ` (${d?.qualification?.toUpperCase()})`
              : ''
            const specialtyPart = d?.specialty ? ` [${d?.specialty}]` : ''
            const displayName =
              `Dr. ${d?.name}${qualificationPart}${specialtyPart}`.trim()
            const doctorRef = d?.id
            return {
              value: displayName,
              label: displayName,
              doctorRef: doctorRef,
            }
          }) || []

    return [selfOption, ...dynamicOptions, externalOption]
  }
  return (
    <div className='orders-container'>
      {/* needed */}
      {/* {!window.location.pathname.startsWith(labordercreate) && ( */}
      <div className='order-buttons'>
        {orders?.map((ord, idx) => (
          <button
            className={`order-btn${
              activeIndex === idx ? ' active-order-btn' : ''
            }`}
            onClick={() => handleIndexChange(idx)}
            key={ord?.id}
            title={`Order ${ord?.id}- ${readableDateTimeFormat(
              new Date(ord?.ordered_on ?? '')
            )}`}
          >
            Order {ord?.id}-{ord?.source ?? ''}-{ord?.origin ?? ''}
          </button>
        ))}
        <button
          className={`order-btn${
            activeIndex === -1 ? ' active-order-btn' : ''
          }`}
          onClick={() => handleIndexChange(-1)}
          // needed
          // disabled={ordersEvent?.every((event) =>
          //   event.tests?.every(
          //     (test) =>
          //       test.status === 'ORDER_MODIFIED' || test.status === 'ORDERED'
          //   )
          // )}
        >
          {NewOrder}
        </button>
      </div>
      {/* )} */}
      <div className='createlaborder-table'>
        <div className='laborder-sub-btn'>
          <Button
            onClick={handleSave}
            disabled={
              isSaving ||
              !newrowadded ||
              visitStatus === 'finished' ||
              ordersEvent?.some((event) =>
                event?.tests?.some(
                  (test) =>
                    test?.status !== 'ORDER_MODIFIED' &&
                    test?.status !== 'ORDERED'
                )
              )
            }
            size='small'
            variant='contained'
          >
            {isSaving ? 'Saving...' : 'Submit'}
          </Button>
        </div>
        <div
          className={
            isPointerEventsDisabled
              ? 'pointer-events-none'
              : 'pointer-events-auto'
          }
        >
          <table className='data-table admin-table'>
            <thead style={{ position: 'sticky', top: '0px' }}>
              <tr>
                <th className='th-mode'>{LmstableHeading?.Mode}</th>
                {locations.pathname.startsWith(labordercreate) && (
                  <>
                    <th className='th-requested'>{LmstableHeading?.Origin}</th>
                    <th className='th-sample'>
                      {LmstableHeading?.RequestedBy}
                    </th>
                  </>
                )}
                <th className='th-test'>{LmstableHeading?.TestName}</th>
                <th className='th-sample'>{LmstableHeading?.Price}</th>
                <th className='th-action'>{LmstableHeading?.Action}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <Select
                    value={newRow?.mode || ''}
                    onChange={handleModeChange}
                    options={[optionValue?.test, optionValue?.package]}
                    isDisabled={isRowAdded}
                  />
                </td>
                {locations.pathname.startsWith(labordercreate) && (
                  <>
                    <td>
                      <Select
                        className='origin-select'
                        isClearable
                        value={newRow?.origin}
                        onChange={handleOriginChange}
                        options={[
                          optionValue?.origin,
                          optionValue?.ipd,
                          optionValue?.b2b,
                          optionValue?.partner,
                          optionValue?.others,
                        ]}
                      />
                    </td>
                    <td>
                      <Select
                        className='origin-select'
                        isClearable
                        value={newRow?.requestedBy || ''}
                        onChange={(selected) => {
                          handleRequestedByChange(selected)
                        }}
                        options={getRequestedByOptions()}
                      />

                      {newRow?.requestedBy?.value ===
                        optionValue?.external?.value && (
                        <input
                          type='text'
                          placeholder={externalName}
                          value={externalText}
                          className='externalName'
                          onChange={(e) => setExternalText(e.target.value)}
                        />
                      )}
                    </td>
                  </>
                )}
                <td>
                  {newRow?.mode?.value === 'test' && (
                    <Select
                      options={testNameOptions?.map((option) => ({
                        ...option,
                        isDisabled: rows?.some(
                          (row) => row?.testName?.value === option?.value
                        ),
                        odoo_test_id: option?.odoo_testId,
                      }))}
                      value={newRow?.testName}
                      onChange={handleTestNameChange}
                    />
                  )}
                </td>
                {priceLoading ? (
                  <span className='loader'>{LoadPrice}</span>
                ) : (
                  <span>₹ {newRow?.price ?? 0}</span>
                )}
                <td>
                  <button onClick={handleSaveRow}>{add}</button>
                </td>
              </tr>
              {rows?.map((row: any, index) => (
                <tr key={index}>
                  <td>{row?.mode?.label}</td>
                  {locations.pathname.startsWith(labordercreate) && (
                    <td>{row?.origin?.label}</td>
                  )}
                  {locations.pathname.startsWith(labordercreate) && (
                    <td>{row?.requestedBy?.value}</td>
                  )}
                  <td>{row?.testName?.label}</td>
                  <td>{row?.panel?.price}</td>
                  <td>
                    <IconButton
                      size='small'
                      onClick={() => handleDeleteRow(index)}
                    >
                      <DeleteOutlinedIcon fontSize='small' />
                    </IconButton>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default OpdOrder
